import { createFileRoute } from "@tanstack/react-router"
import { MarketingMailingsPage } from "@/pages/marketing-mailings"

export const Route = createFileRoute("/(marketing)/marketing/mailings/")({
	component: MarketingMailingsPage,
})
